export const pdfType = 'pdf';
export const imageType = 'img';

export const controlTypes = {
  preview: 'preview',
  download: 'download',
  upload: 'upload',
};
